module.exports = __webpack_public_path__ + "static/gallery13-70f5ebfe4170492baf92ad00b0a1cec0.jpg";